import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbCarousel, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { UploadedFile } from '../../../../../models/entities/uploaded-file';
import { CommonModule } from '@angular/common';
import { PayableAttachmentPreviewComponent } from '../payable-attachment-preview/payable-attachment-preview.component';

@Component({
  selector: 'app-payable-attachment-carousel',
  templateUrl: './payable-attachment-carousel.component.html',
  styleUrls: ['./payable-attachment-carousel.component.scss'],
  encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        PayableAttachmentPreviewComponent,
        NgbCarouselModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PayableAttachmentCarouselComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() attachments: UploadedFile[];
    @Input() emptyMessage: string = 'No attachments available';
    @Input() showCaptions: boolean = false;
    @ViewChild('payableCarousel') carousel: NgbCarousel;
    containerHeight: string;

    constructor(
        private _elementRef: ElementRef,
    ) { }

    ngOnInit(): void {
        this.setHeight();

        window.addEventListener('resize', () => {
            this.setHeight();
        });
    }
    ngAfterViewInit(): void {
        this.pauseCarousel();
        setTimeout(() => this.setHeight(), 0);
    }

    ngOnChanges(changes:SimpleChanges): void {
        if(changes.attachments && changes.attachments.firstChange) {
            this.pauseCarousel();
        }
    }
    pauseCarousel() {
        setTimeout(() => {
            if (this.carousel) {
                this.carousel.pause();
            }
        }, 500);
    }
    selectAttachment(attachmentId: number) {
        // wait to make sure the carousel is loaded
        setTimeout(() => {
            this.carousel.select(attachmentId.toString());
        }, 500);
    }
    setHeight(): void {
        const dialogContent = this.findDialogContent();

        if (dialogContent) {
            const availableHeight = Math.max(dialogContent.clientHeight - 225, 400);

            this.containerHeight = `${availableHeight}px`;
        } else {
            this.containerHeight = '575px';
        }
    }
    private findDialogContent(): HTMLElement | null {
        let element: HTMLElement | null = this._elementRef.nativeElement;
        while (element && element !== document.documentElement) {
            if (element.tagName === 'PH-DIALOG') {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }

    trackByAttachmentId(index: number, attachment: UploadedFile): number {
        return attachment.id;
    }
}
